module.exports = {"131122100":"武邑镇","131122101":"清凉店镇","131122102":"审坡镇","131122103":"赵桥镇","131122104":"韩庄镇","131122105":"肖桥头镇","131122200":"龙店乡","131122201":"圈头乡","131122203":"大紫塔乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131122.json
// module id = 219
// module chunks = 0